import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[onlyAlphabet]'
})
export class OnlyAlphabetDirective {
  private readonly navKeys = new Set([
    'Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
    'Tab', 'Delete', 'Home', 'End'
  ]);

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;
    const isShortcut = (event.ctrlKey || event.metaKey) && ['a','c','v','x','z','y'].includes(key.toLowerCase());
    if (this.navKeys.has(key) || isShortcut) return;
    if (!/^[a-zA-Z]$/.test(key)) event.preventDefault();
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const text = event.clipboardData?.getData('text/plain') ?? '';
    if (!/^[a-zA-Z]+$/.test(text)) {
      event.preventDefault();
      const sanitized = text.replace(/[^a-zA-Z]/g, '');
      const target = event.target as HTMLInputElement | HTMLTextAreaElement;
      const start = target.selectionStart ?? target.value.length;
      const end = target.selectionEnd ?? target.value.length;
      target.setRangeText(sanitized, start, end, 'end');
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    const text = event.dataTransfer?.getData('text') ?? '';
    if (!/^[a-zA-Z]+$/.test(text)) event.preventDefault();
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const el = event.target as HTMLInputElement | HTMLTextAreaElement;
    const cleaned = el.value.replace(/[^a-zA-Z]/g, '');
    if (cleaned !== el.value) {
      const pos = el.selectionStart ?? cleaned.length;
      el.value = cleaned;
      try { el.setSelectionRange(pos, pos); } catch {}
    }
  }
}
